import styled from '@emotion/styled'
import { motion } from 'framer-motion'

export const MotionContainer = styled(motion.div)`
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100%;
  margin: 0 auto;
  padding: 30px 0;
  text-align: center;
`
